import { computed } from 'vue'
import { useWindowSize } from '@vueuse/core'

export type AppMode = 'desktop' | 'mobile'

// Default breakpoint for mobile/desktop switch
export const DEFAULT_MOBILE_BREAKPOINT = 1024

export const useAppMode = (breakpoint: number = DEFAULT_MOBILE_BREAKPOINT) => {
  const { width: windowWidth } = useWindowSize()

  const mode = computed<AppMode>(() => {
    return windowWidth.value > breakpoint ? 'desktop' : 'mobile'
  })

  const isMobile = computed(() => mode.value === 'mobile')

  return { mode, windowWidth, isMobile }
}
